<script lang="ts">
    import NauiSlideOver from "../../naui/layout/NauiSlideOver.svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import NauiTextarea from "../../naui/atoms/NauiTextarea.svelte";
    import type {ApprovalAction} from "../../interfaces/precio-item.interface";

    export let open: boolean = false;
    export let id: number;
    export let status: ApprovalAction = {
        label: 'APROBAR',
        action: {
            label: 'Aprobado',
            value: 'aprobado'
        }
    };
    export let date: string;
    export let user: any;
    export let comment: string = null;
</script>
<NauiSlideOver bind:open={open}
               title="Observaciones de la revisión">
    <div>
        <div class="box-l mb-15">
            <div class="status" class:rejected={status.action.value === 'rechazado'}>
                {status?.action?.label}
            </div>
        </div>
        {#if user}
            <div class="mb-15">
                <NauiInput value={user.user.full_name}
                           label="Revisado por "
                           type="text"
                           isDisabled={true}/>
            </div>
        {/if}
        {#if date}
            <div class="mb-15">
                <NauiInput value={date}
                           label="Fecha"
                           type="text"
                           isDisabled={true}/>
            </div>
        {/if}
        {#if comment}
            <div>
                <NauiTextarea label="Observaciones"
                              isDisabled={true}
                              value={comment}/>
            </div>
        {/if}
    </div>
</NauiSlideOver>
<style>
    .status {
        background: #3F9C35;
        color: #fff;
        padding: .2rem 1rem;
        font-weight: 900;
        border-radius: 20px;
        text-transform: uppercase;
    }

    .status.rejected {
        background: #F44336;
    }
</style>